import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  bulkInventoryBinService,
  type DisposeReturnToInventoryRequest,
  type DisposeReturnToInventoryResponse,
} from '@/services/propertyBook/BulkInventoryBinService';
import { queryKeys } from '@/lib/queryKeys';

export const useReturnToInventoryFromDisposal = () => {
  const queryClient = useQueryClient();

  return useMutation<DisposeReturnToInventoryResponse, unknown, DisposeReturnToInventoryRequest>({
    mutationFn: (payload) => bulkInventoryBinService.returnToInventoryFromDisposal(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.bulkInventoryBin.all });
      void queryClient.invalidateQueries({ queryKey: queryKeys.entities.lists() });
      void queryClient.invalidateQueries({ queryKey: ['transaction-log'] });
      void queryClient.invalidateQueries({ queryKey: ['exchange-replacement-options'] });
      void queryClient.invalidateQueries({ queryKey: ['asset-inventory'] });
    },
  });
};
